// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609041421/js/" + chunkId + "." + {"44":"0955f7ce","225":"576fe2c2","481":"b139d354","486":"f72d8965","770":"e392f7c1"}[chunkId] + ".0.8052208992390966.chunk.js";
};